import React, { Component } from 'react';
import './App.css';
import ScreenContext from './ScreenContext';
import img_elRoundimage from './images/TeamMember_elRoundimage_812940.png';

export default class TeamMember extends Component {

  static contextType = ScreenContext;

  // Properties used by this component:
  // name, description, image

  constructor(props) {
    super(props);
    
    this.state = {
      text: (<div> </div>),
      text_plainText: " ",
      textcopy: (<div> </div>),
      textcopy_plainText: " ",
    };
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  componentDidUpdate(prevProps, prevState) {
  }

  render() {
    const style_elRoundimage = {
      backgroundImage: 'url('+this.context.appActions.createImageUrlFromProp(this.props.image)+')',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '50% 50%',
      backgroundSize: 'cover',
     };
    
    const value_text = ((val) => {
      // make sure value is in string format
      if (val instanceof String || typeof val === 'string') return val;
      else {
        try {
          return JSON.stringify(val);
        }
        catch (e) {
          return val.toString();
        }
      }
    })(this.props.name);
    
    const style_elText = {
      fontSize: 20.3,
      color: '#fffefe',
      textAlign: 'center',
     };
    
    const value_textCopy = ((val) => {
      // make sure value is in string format
      if (val instanceof String || typeof val === 'string') return val;
      else {
        try {
          return JSON.stringify(val);
        }
        catch (e) {
          return val.toString();
        }
      }
    })(this.props.description);
    
    const style_elTextCopy = {
      fontSize: 15.8,
      color: '#fffefe',
      textAlign: 'center',
     };
    
    const style_elSpacer = {
      background: 'rgba(0, 0, 0, 1.000)',
     };
    
    return (
      <div className="TeamMember">
        <div className="layoutFlow">
          <div className="elRoundimage">
            <div style={style_elRoundimage} />
          </div>
          
          <div className="elText">
            <div className="font-AppleSystemUIFont" style={style_elText}>
              <div>{value_text}</div>
            </div>
          </div>
          
          <div className="elTextCopy">
            <div className="font-caesarDressingRegular" style={style_elTextCopy}>
              <div>{value_textCopy}</div>
            </div>
          </div>
          
          <div className="elSpacer">
            <div style={style_elSpacer} />
          </div>
        </div>
        
      </div>
    )
  }
  
}
